import { Logout } from "@mui/icons-material";
import { Avatar, ListItemIcon, Menu, MenuItem } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { titleAtoms } from "../../shared/atoms/titleAtoms";
import { removeToken } from "../../shared/helpers";
import logo from "./assets/logo-mostrans.png";
import { MenuAdmin } from "./listItems";

import IconButton from "@mostrans/web-components/components/base/IconButton";
import { authTokenAtom } from "../../shared/globalStates";

const drawerWidth = 240;

const DivHeader = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "fixed",
  height: "60px",
  backgroundColor: "#fff",
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(4),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(4),
      },
    }),
  },
}));

function SideBar() {
  const title = useRecoilValue(titleAtoms);
  const [openMenuMaster, setOpenMenuMaster] = useState(false);
  const [open, setOpen] = useState(false);
  const setToken = useSetRecoilState(authTokenAtom);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = () => {
    setOpen(true);
    setOpenMenuMaster(false);
  };
  const history = useHistory();

  const closeToggleDrawer = () => {
    setOpen(false);
    setOpenMenuMaster(false);
  };

  const handleLogout = () => {
    removeToken();
    setToken([]);
    history.push("/");
  };

  return (
    <>
      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={toggleDrawer}
        onMouseLeave={closeToggleDrawer}
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            px: [1],
          }}
        >
          <Avatar
            src={logo}
            sx={{ width: 50, height: 50, marginRight: "15px" }}
          />
          <Typography variant="h6" color="#07784A" sx={{ flexGrow: 1 }}>
            Mostrans Career
          </Typography>
        </Toolbar>
        <List component="nav" sx={{ mt: 2 }}>
          <MenuAdmin
            openMenuMaster={openMenuMaster}
            setOpenMenuMaster={setOpenMenuMaster}
          />
        </List>
      </Drawer>
      <DivHeader position="absolute" open={open}>
        <Toolbar
          sx={{
            pr: "24px",
          }}
        >
          {open ? null : (
            <Avatar
              src={logo}
              sx={{ width: 50, height: 50, marginLeft: "-35px" }}
            />
          )}
          <Typography
            variant="h5"
            color="primary"
            sx={{ fontWeight: 500, flexGrow: 1, ml: 2 }}
          >
            {title}
          </Typography>
          <div>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar src={logo} sx={{ width: 50, height: 50 }} />
            </IconButton>
          </div>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={openMenu}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{
              horizontal: "right",
              vertical: "top",
            }}
            anchorOrigin={{
              horizontal: "right",
              vertical: "bottom",
            }}
          >
            <MenuItem onClick={() => handleLogout()}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </DivHeader>
    </>
  );
}

export default SideBar;
